export default {
  title: "싸인텔레콤"
};
